"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugins = exports.default = exports.components = exports.actions = void 0;
var _Accordion = _interopRequireDefault(require("./components/Accordion"));
var _ActivityCard = _interopRequireDefault(require("./components/ActivityCard"));
var _Architecture = _interopRequireDefault(require("./components/Architecture"));
var _AreaCard = _interopRequireDefault(require("./components/AreaCard"));
var _AudiovideoBanner = _interopRequireDefault(require("./components/AudiovideoBanner"));
var _Banner = _interopRequireDefault(require("./components/Banner"));
var _BannerContainer = _interopRequireDefault(require("./components/BannerContainer"));
var _BannerOffsetContainer = _interopRequireDefault(require("./components/BannerOffsetContainer"));
var _Benefits = _interopRequireDefault(require("./components/Benefits"));
var _BenefitsTab = _interopRequireDefault(require("./components/BenefitsTab"));
var _BottomBanner = _interopRequireDefault(require("./components/BottomBanner"));
var _BrandEquity = _interopRequireDefault(require("./components/BrandEquity"));
var _Button = _interopRequireDefault(require("./components/Button"));
var _BuyNowNew = _interopRequireDefault(require("./components/BuyNowNew"));
var _BuyProduct = _interopRequireDefault(require("./components/BuyProduct1"));
var _BuyProduct2 = _interopRequireDefault(require("./components/BuyProduct2"));
var _BuyProduct3 = _interopRequireDefault(require("./components/BuyProduct3"));
var _BuyProduct4 = _interopRequireDefault(require("./components/BuyProduct4"));
var _CertificationSystem = _interopRequireDefault(require("./components/CertificationSystem"));
var _CircleLogoText = _interopRequireDefault(require("./components/CircleLogoText"));
var _ClassifyTabContainer = _interopRequireDefault(require("./components/ClassifyTabContainer"));
var _Code = _interopRequireDefault(require("./components/Code"));
var _Contact = _interopRequireDefault(require("./components/Contact"));
var _CouponOMTwo = _interopRequireDefault(require("./components/CouponOMTwo"));
var _DiscountPurchaseCard = _interopRequireDefault(require("./components/DiscountPurchaseCard"));
var _ExclusiveBenefits = _interopRequireDefault(require("./components/ExclusiveBenefits"));
var _Faq = _interopRequireDefault(require("./components/Faq"));
var _FlexCustomersTab = _interopRequireDefault(require("./components/FlexCustomersTab"));
var _FlexInternationalLogo = _interopRequireDefault(require("./components/FlexInternationalLogo"));
var _FlexNavigate = _interopRequireDefault(require("./components/FlexNavigate"));
var _FlexQuickStartsTab = _interopRequireDefault(require("./components/FlexQuickStartsTab"));
var _FlexTitle = _interopRequireDefault(require("./components/FlexTitle"));
var _FormTable = _interopRequireDefault(require("./components/FormTable"));
var _FreeWithBuyNowNew = _interopRequireDefault(require("./components/FreeWithBuyNowNew"));
var _FreeWithCardNew = _interopRequireDefault(require("./components/FreeWithCardNew"));
var _FreeWithCredit = _interopRequireDefault(require("./components/FreeWithCredit"));
var _FreeWithCreditIteration = _interopRequireDefault(require("./components/FreeWithCreditIteration"));
var _FunctionalComparison = _interopRequireDefault(require("./components/FunctionalComparison"));
var _GrowthPlan = _interopRequireDefault(require("./components/GrowthPlan"));
var _IconText = _interopRequireDefault(require("./components/IconText"));
var _LessonPlan = _interopRequireDefault(require("./components/LessonPlan"));
var _LogoText = _interopRequireDefault(require("./components/LogoText"));
var _MarketCard = _interopRequireDefault(require("./components/MarketCard"));
var _MenuContainer = _interopRequireDefault(require("./components/MenuContainer"));
var _MenuPanelContainer = _interopRequireDefault(require("./components/MenuPanelContainer"));
var _MultipleScenarios = _interopRequireDefault(require("./components/MultipleScenarios"));
var _NewBanner = _interopRequireDefault(require("./components/NewBanner"));
var _NewBannerWithInfo = _interopRequireDefault(require("./components/NewBannerWithInfo"));
var _Notice = _interopRequireDefault(require("./components/Notice"));
var _NumberCard = _interopRequireDefault(require("./components/NumberCard"));
var _Operate = _interopRequireDefault(require("./components/Operate"));
var _PackageCard = _interopRequireDefault(require("./components/PackageCard"));
var _PackageSwitch = _interopRequireDefault(require("./components/PackageSwitch"));
var _Partner = _interopRequireDefault(require("./components/Partner"));
var _PdfView = _interopRequireDefault(require("./components/PdfView"));
var _PicText = _interopRequireDefault(require("./components/PicText"));
var _PriceSet = _interopRequireDefault(require("./components/PriceSet"));
var _PriceSetTab = _interopRequireDefault(require("./components/PriceSetTab"));
var _ProductCards = _interopRequireDefault(require("./components/ProductCards"));
var _ProductIntroduction = _interopRequireDefault(require("./components/ProductIntroduction"));
var _ProductResource = _interopRequireDefault(require("./components/ProductResource"));
var _ProductsService = _interopRequireDefault(require("./components/ProductsService"));
var _ProductsSpecific = _interopRequireDefault(require("./components/ProductsSpecific"));
var _PublishPrice = _interopRequireDefault(require("./components/PublishPrice"));
var _PublishPriceTab = _interopRequireDefault(require("./components/PublishPriceTab"));
var _Quickstarts = _interopRequireDefault(require("./components/Quickstarts"));
var _RecommendCard = _interopRequireDefault(require("./components/RecommendCard"));
var _RelatedProducts = _interopRequireDefault(require("./components/RelatedProducts"));
var _SMEFreeCard = _interopRequireDefault(require("./components/SMEFreeCard"));
var _SMEFreeTabCard = _interopRequireDefault(require("./components/SMEFreeTabCard"));
var _Scenarios = _interopRequireDefault(require("./components/Scenarios"));
var _ScenariosCard = _interopRequireDefault(require("./components/ScenariosCard"));
var _SceneChange = _interopRequireDefault(require("./components/SceneChange"));
var _SceneIntroduce = _interopRequireDefault(require("./components/SceneIntroduce"));
var _SceneTabs = _interopRequireDefault(require("./components/SceneTabs"));
var _SceneTabsRelevance = _interopRequireDefault(require("./components/SceneTabsRelevance"));
var _SelectCard = _interopRequireDefault(require("./components/SelectCard"));
var _SelectPaginationContainer = _interopRequireDefault(require("./components/SelectPaginationContainer"));
var _ShortBanner = _interopRequireDefault(require("./components/ShortBanner"));
var _SpecialOffers = _interopRequireDefault(require("./components/SpecialOffers"));
var _StoriesScenarios = _interopRequireDefault(require("./components/StoriesScenarios"));
var _StudentCenterBanner = _interopRequireDefault(require("./components/StudentCenterBanner"));
var _TextUrl = _interopRequireDefault(require("./components/TextUrl"));
var _TxtCard = _interopRequireDefault(require("./components/TxtCard"));
var _Whitepaper = _interopRequireDefault(require("./components/Whitepaper"));
var _BindUser = _interopRequireDefault(require("./plugins/BindUser"));
var _CheckLogin = _interopRequireDefault(require("./actions/CheckLogin"));
const components = exports.components = {
  Accordion: {
    component: _Accordion.default
  },
  ActivityCard: {
    component: _ActivityCard.default
  },
  Architecture: {
    component: _Architecture.default
  },
  AreaCard: {
    component: _AreaCard.default
  },
  AudiovideoBanner: {
    component: _AudiovideoBanner.default
  },
  Banner: {
    component: _Banner.default
  },
  BannerContainer: {
    component: _BannerContainer.default
  },
  BannerOffsetContainer: {
    component: _BannerOffsetContainer.default
  },
  Benefits: {
    component: _Benefits.default
  },
  BenefitsTab: {
    component: _BenefitsTab.default
  },
  BottomBanner: {
    component: _BottomBanner.default
  },
  BrandEquity: {
    component: _BrandEquity.default
  },
  Button: {
    component: _Button.default
  },
  BuyNowNew: {
    component: _BuyNowNew.default
  },
  BuyProduct1: {
    component: _BuyProduct.default
  },
  BuyProduct2: {
    component: _BuyProduct2.default
  },
  BuyProduct3: {
    component: _BuyProduct3.default
  },
  BuyProduct4: {
    component: _BuyProduct4.default
  },
  CertificationSystem: {
    component: _CertificationSystem.default
  },
  CircleLogoText: {
    component: _CircleLogoText.default
  },
  ClassifyTabContainer: {
    component: _ClassifyTabContainer.default
  },
  Code: {
    component: _Code.default
  },
  Contact: {
    component: _Contact.default
  },
  CouponOMTwo: {
    component: _CouponOMTwo.default
  },
  DiscountPurchaseCard: {
    component: _DiscountPurchaseCard.default
  },
  ExclusiveBenefits: {
    component: _ExclusiveBenefits.default
  },
  Faq: {
    component: _Faq.default
  },
  FlexCustomersTab: {
    component: _FlexCustomersTab.default
  },
  FlexInternationalLogo: {
    component: _FlexInternationalLogo.default
  },
  FlexNavigate: {
    component: _FlexNavigate.default
  },
  FlexQuickStartsTab: {
    component: _FlexQuickStartsTab.default
  },
  FlexTitle: {
    component: _FlexTitle.default
  },
  FormTable: {
    component: _FormTable.default
  },
  FreeWithBuyNowNew: {
    component: _FreeWithBuyNowNew.default
  },
  FreeWithCardNew: {
    component: _FreeWithCardNew.default
  },
  FreeWithCredit: {
    component: _FreeWithCredit.default
  },
  FreeWithCreditIteration: {
    component: _FreeWithCreditIteration.default
  },
  FunctionalComparison: {
    component: _FunctionalComparison.default
  },
  GrowthPlan: {
    component: _GrowthPlan.default
  },
  IconText: {
    component: _IconText.default
  },
  LessonPlan: {
    component: _LessonPlan.default
  },
  LogoText: {
    component: _LogoText.default
  },
  MarketCard: {
    component: _MarketCard.default
  },
  MenuContainer: {
    component: _MenuContainer.default
  },
  MenuPanelContainer: {
    component: _MenuPanelContainer.default
  },
  MultipleScenarios: {
    component: _MultipleScenarios.default
  },
  NewBanner: {
    component: _NewBanner.default
  },
  NewBannerWithInfo: {
    component: _NewBannerWithInfo.default
  },
  Notice: {
    component: _Notice.default
  },
  NumberCard: {
    component: _NumberCard.default
  },
  Operate: {
    component: _Operate.default
  },
  PackageCard: {
    component: _PackageCard.default
  },
  PackageSwitch: {
    component: _PackageSwitch.default
  },
  Partner: {
    component: _Partner.default
  },
  PdfView: {
    component: _PdfView.default
  },
  PicText: {
    component: _PicText.default
  },
  PriceSet: {
    component: _PriceSet.default
  },
  PriceSetTab: {
    component: _PriceSetTab.default
  },
  ProductCards: {
    component: _ProductCards.default
  },
  ProductIntroduction: {
    component: _ProductIntroduction.default
  },
  ProductResource: {
    component: _ProductResource.default
  },
  ProductsService: {
    component: _ProductsService.default
  },
  ProductsSpecific: {
    component: _ProductsSpecific.default
  },
  PublishPrice: {
    component: _PublishPrice.default
  },
  PublishPriceTab: {
    component: _PublishPriceTab.default
  },
  Quickstarts: {
    component: _Quickstarts.default
  },
  RecommendCard: {
    component: _RecommendCard.default
  },
  RelatedProducts: {
    component: _RelatedProducts.default
  },
  SMEFreeCard: {
    component: _SMEFreeCard.default
  },
  SMEFreeTabCard: {
    component: _SMEFreeTabCard.default
  },
  Scenarios: {
    component: _Scenarios.default
  },
  ScenariosCard: {
    component: _ScenariosCard.default
  },
  SceneChange: {
    component: _SceneChange.default
  },
  SceneIntroduce: {
    component: _SceneIntroduce.default
  },
  SceneTabs: {
    component: _SceneTabs.default
  },
  SceneTabsRelevance: {
    component: _SceneTabsRelevance.default
  },
  SelectCard: {
    component: _SelectCard.default
  },
  SelectPaginationContainer: {
    component: _SelectPaginationContainer.default
  },
  ShortBanner: {
    component: _ShortBanner.default
  },
  SpecialOffers: {
    component: _SpecialOffers.default
  },
  StoriesScenarios: {
    component: _StoriesScenarios.default
  },
  StudentCenterBanner: {
    component: _StudentCenterBanner.default
  },
  TextUrl: {
    component: _TextUrl.default
  },
  TxtCard: {
    component: _TxtCard.default
  },
  Whitepaper: {
    component: _Whitepaper.default
  }
};
const plugins = exports.plugins = {
  BindUser: {
    plugin: _BindUser.default
  }
};
const actions = exports.actions = {
  CheckLogin: {
    action: _CheckLogin.default
  }
};
var _default = exports.default = {
  components,
  plugins,
  actions
};